import {
    LIST_INHIBITIONS,
    LIST_INHIBITIONS_SUCCESS,
    LIST_INHIBITIONS_ERROR,
    ADD_INHIBITIONS,
    SAVE_INHIBITIONS,
    SAVE_INHIBITIONS_SUCCESS,
    SAVE_INHIBITIONS_ERROR,
    DELETE_INHIBITIONS,
    DELETE_INHIBITIONS_SUCCESS,
    DELETE_INHIBITIONS_ERROR,
    EDIT_INHIBITIONS,
    UPDATE_INHIBITIONS,
    UPDATE_INHIBITIONS_SUCCESS,
    UPDATE_INHIBITIONS_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import inhibitionsData from '../data/inhibitions';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'inhibicion';

//LISTAR INHIBITIONS
export function listInhibitionsAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listInhibitions() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const inhibitions = response.data;
            //const inhibitions = inhibitionsData;
            //Llamo al dispatch
            dispatch( listInhibitionsSuccess(inhibitions) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listInhibitionsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listInhibitions = () => ({
    type: LIST_INHIBITIONS,
    payload: true
});

const listInhibitionsSuccess = inhibitions => ({
    type: LIST_INHIBITIONS_SUCCESS,
    payload: inhibitions
});

const listInhibitionsError = error => ({
    type: LIST_INHIBITIONS_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addInhibitionsAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addInhibitions(false) );
        //Abro el formulario
        showForm();
    }
}

const addInhibitions = isEdit => ({
    type: ADD_INHIBITIONS,
    payload: isEdit
});

//SAVE AUDIENCE CATEGORY
export function saveInhibitionsAction(inhibition, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveInhibitions() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, inhibition);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveInhibitionsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveInhibitionsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveInhibitions = () => ({
    type: SAVE_INHIBITIONS,
    payload: true
});


const saveInhibitionsSuccess = inhibition => ({
    type: SAVE_INHIBITIONS_SUCCESS,
    payload: inhibition
});

const saveInhibitionsError = error => ({
    type: SAVE_INHIBITIONS_ERROR,
    payload: error
});

//EDIT AUDIENCE CATEGORY
export function editInhibitionsAction(inhibition, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editInhibitions(inhibition) );
        //Abro el formulario
        showForm();
    }
}

const editInhibitions = inhibition => ({
    type: EDIT_INHIBITIONS,
    payload: inhibition
});

//UPDATE AUDIENCE CATEGORY
export function updateInhibitionsAction(inhibition, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateInhibitions() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${inhibition.id}`, inhibition);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateInhibitionsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateInhibitionsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateInhibitions = () => ({
    type: UPDATE_INHIBITIONS,
    payload: true
});

const updateInhibitionsSuccess = inhibition => ({
    type: UPDATE_INHIBITIONS_SUCCESS,
    payload: inhibition
});

const updateInhibitionsError = error => ({
    type: UPDATE_INHIBITIONS_ERROR,
    payload: error
});

//DELETE AUDIENCE CATEGORY
export function deleteInhibitionsAction(inhibition) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteInhibitions() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${inhibition.id}`);
            const response = await clienteAxios.put(`/${controller}/${inhibition.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteInhibitionsSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteInhibitionsError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteInhibitions = () => ({
    type: DELETE_INHIBITIONS,
    payload: true
});

const deleteInhibitionsSuccess = inhibition => ({
    type: DELETE_INHIBITIONS_SUCCESS,
    payload: inhibition
});

const deleteInhibitionsError = error => ({
    type: DELETE_INHIBITIONS_ERROR,
    payload: error
});